export default "__VITE_ASSET__CLF05_wj__"